import { Popover, PopoverContent, PopoverTrigger, Portal } from '@chakra-ui/react';
import {
  ActionArrowRightIcon,
  CloudDownloadIcon,
  DeleteIcon,
  DuplicateIcon,
  MoreIcon,
  RedoIcon,
} from '@sketchnote/icons';
import { IconTextBtn } from '@sketchnote/shared-components';
import cn from 'classnames';
import { Resizable } from 're-resizable';
import * as React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { Node, NodeProps } from 'slate';
import { useReadOnly } from 'slate-react';

const { useState, useMemo } = React;

export interface ImageRenderProps {
  isSelected: boolean;
  imgWidth: number;
  onChangeImgWidth: (width: number) => void;
  caption: {
    isOpen: boolean;
    text: any[];
  };
  onChangeCaption: (text: string) => void;
  url: string;
  onToggleCaption: () => void;
  nodeProps?: NodeProps;
  onDelete: () => void;
  onDuplicate: () => void;
  onReplace: () => void;
}

export const ImageRender = ({
  imgWidth,
  onChangeImgWidth,
  caption,
  onChangeCaption,
  url,
  onToggleCaption,
  nodeProps,
  onDelete,
  onDuplicate,
  onReplace,
}: ImageRenderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const isReadOnly = useReadOnly();
  const isEnable = !isReadOnly;

  const toggleMenu = (value?: boolean) => () => {
    setIsOpen(value ?? !isOpen);
  };

  const captionString = useMemo(() => {
    return caption?.text?.[0] ? Node.string(caption.text[0]) : '';
  }, [caption]);

  const handleOnDownload = () => {
    const link = document.createElement('a');
    link.rel = 'noreferrer';
    link.target = '_blank';
    link.href = `/api/downloader?path=${encodeURIComponent(url)}`;
    link.download = 'Image';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleOnViewOriginal = () => {
    const link = document.createElement('a');
    link.rel = 'noreferrer';
    link.target = '_blank';
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <React.Fragment>
      <figure>
        <Resizable
          maxWidth="100%"
          className={cn('mx-auto editor-image-renderer')}
          defaultSize={{ width: imgWidth, height: '100%' }}
          resizeRatio={1.5}
          enable={{
            left: isEnable,
            right: isEnable,
          }}
          handleComponent={{
            left: <div className="editor-image-handle handle-left"></div>,
            right: <div className="editor-image-handle handle-right"></div>,
          }}
          handleStyles={{
            left: { left: 8 },
            right: { right: 5 },
          }}
          lockAspectRatio={true}
          onResizeStop={(e, direction, ref) => onChangeImgWidth(ref.offsetWidth)}
        >
          {/* <img src={url} className="w-full h-full rounded-sm" alt={captionString} {...nodeProps} /> */}
          <img src={url} className="w-full h-full rounded-sm" alt={captionString} />
          <div
            className={cn(
              'absolute top-8 right-8 rounded-sm bg-white px-12 py-4 editor-image-renderer-toolbar',
              { hidden: !isOpen, flex: isOpen }
            )}
          >
            <button
              disabled={isReadOnly}
              className="text-gray-600 text-sm"
              onClick={onToggleCaption}
            >
              Caption
            </button>
            <span className="border-r mx-10"></span>
            <Popover
              placement="bottom"
              isOpen={isOpen}
              onOpen={toggleMenu(true)}
              onClose={toggleMenu(false)}
              modifiers={[{ name: 'eventListeners', options: { scroll: isOpen } }]}
            >
              <PopoverTrigger>
                <button disabled={isReadOnly} className="flex items-center text-gray-600">
                  <MoreIcon wrapperClass="" />
                </button>
              </PopoverTrigger>
              <Portal>
                {/* <PopoverContent>
                  <div className="flex flex-col p-6 rounded-lg bg-white shadow-md text-gray-999 min-w-144">
                    <IconTextBtn
                      className="px-8 py-10 hover:bg-gray-100 rounded-sm"
                      onClick={onDuplicate}
                      iconLeft={<DuplicateIcon className="mr-6 text-gray-500" />}
                    >
                      Duplicate
                    </IconTextBtn>
                    <IconTextBtn
                      className="px-8 py-10 hover:bg-gray-100 rounded-sm"
                      onClick={onReplace}
                      iconLeft={<RedoIcon className="mr-6 text-gray-500" />}
                    >
                      Replace
                    </IconTextBtn>
                    <IconTextBtn
                      className="px-8 py-10 hover:bg-gray-100 rounded-sm"
                      onClick={onDelete}
                      iconLeft={<DeleteIcon className="mr-6 text-gray-500" />}
                    >
                      Delete
                    </IconTextBtn>
                    <IconTextBtn
                      className="px-8 py-10 hover:bg-gray-100 rounded-sm"
                      onClick={handleOnDownload}
                      iconLeft={<CloudDownloadIcon className="mr-6 text-gray-500" />}
                    >
                      Download
                    </IconTextBtn>
                    <IconTextBtn
                      className="px-8 py-10 hover:bg-gray-100 rounded-sm"
                      onClick={handleOnViewOriginal}
                      iconLeft={<ActionArrowRightIcon className="mr-6 text-gray-500" />}
                    >
                      View Original
                    </IconTextBtn>
                  </div>
                </PopoverContent> */}
              </Portal>
            </Popover>
          </div>
          <figcaption>
            {caption?.isOpen ? (
              <TextareaAutosize
                className="placeholder-gray-400 text-gray-600 w-full bg-transparent"
                placeholder="Write a caption"
                disabled={isReadOnly}
                value={caption.text?.[0]?.children?.[0].text}
                onChange={(e) => onChangeCaption(e.target.value)}
              />
            ) : null}
          </figcaption>
        </Resizable>
      </figure>
    </React.Fragment>
  );
};
